import { Component, OnInit } from '@angular/core';
import {HssResponse} from '../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import {InfoApiService} from '../../../services/rest-api/info.api.service';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {InfoDataService} from '../../../services/rest-api/info-data.service';
import {StorageService} from '../../../services/rest-api/storage.service';
import {SeoService} from '../../../services/seo/seo.service';
import {NotifyxService} from '../../../services/notify/notifyx.service';

@Component({
  selector: 'app-degree-details',
  templateUrl: './degree-details.component.html',
  styleUrls: ['./degree-details.component.scss']
})
export class DegreeDetailsComponent implements OnInit {

  degreeCourseData: any[] = [];
  degreeData: any[] = [];
  selectedDegree: any;

  private deptId: number = 0;

  imgCollection: any[] = [];


  constructor(
    private _info: InfoApiService,
    private _actRoute: ActivatedRoute,
    private _activatedRoute: ActivatedRoute,
    private _infoData: InfoDataService,
    private router: Router,
    private storage: StorageService,
    private seo: SeoService,
    private notify: NotifyxService
  ) {
    this._actRoute.paramMap.subscribe(params => {
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    const degreeid = this._actRoute.snapshot.params.degreeid;
    // this.selectedDegree = JSON.parse(<any> params.event);

    this.getCoursesByDegId(degreeid);

    // get selected degree from local storage
    const locaDeptDegData = this.storage.getData('deptDegreeData');
    const degrees = locaDeptDegData ? JSON.parse(locaDeptDegData): [];
    this.selectedDegree = this.getDegree(degrees, degreeid);
    this.notify.log('this.selectedDegree',this.selectedDegree);

    this.seo.setMeta(this.selectedDegree.degree_name)

    this.degreeData = degrees;

      if(this.selectedDegree.graprofile_img !== null){
        this.imgCollection = [
          {
            image: this.selectedDegree.graprofile_img,
            thumbImage: this.selectedDegree.graprofile_img,
            alt: 'Graduate profile',
            title: 'Graduate profile'
          },
        ];
      } else {
        this.imgCollection=[];
      }
  }

  navigatePage(current: string, param?: number) {
  if (current === 'degreedet') {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          event: JSON.stringify(param)
        }
      };
      this.router.navigate(['degreedet/'],navigationExtras);
    }
  }

  // View degree courses by degree id
  getDegreByDegId(degId: number){
    this._info.getCourseByDegId(degId).subscribe (
      (response: HssResponse<any>) => {
        this.degreeCourseData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // View degree courses by degree id
  getCoursesByDegId(degId: number){
    this._info.getCourseByDegId(degId).subscribe (
      (response: HssResponse<any>) => {
        this.degreeCourseData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // View degrees by department id
  // getDegreesByDept(deptId: number){
  //   this._info.getDegreesByDept(deptId).subscribe (
  //     (response: HssResponse<any>) => {
  //       this.degreeData = response.body;
  //
  //     },
  //     (error: HssErrorResponse<any>) => {
  //       // Show the failed message
  //       const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
  //       c
  //     }
  //   );
  // }

  // load single info item from stored array
  getDegree(dataArray: any, degId: string){
    const result:any[] = dataArray.filter(function(item:any){
      // Convert item id also to string for matching
      const itemId = item.id.toString();
      return itemId == degId;
    });
    return (result.length > 0 && result[0]) ? result[0] : "";
  }
}
